import { AssistChip, Placeholder, Skeleton, Stack } from '@sixui/ui';

import type { ITableRowProps } from '~/components/molecules/Table/TableRow';
import { Table } from '~/components/molecules/Table';

export type IAdListItemSkeletonProps = ITableRowProps;

export const AdListItemSkeleton: React.FC<IAdListItemSkeletonProps> = (
  props,
) => {
  const { ...other } = props;

  return (
    <Table.Row {...other}>
      <Stack as={Table.Body} horizontal gap={3}>
        <Placeholder width={64} height={64}>
          <Skeleton variant="overlay" />
        </Placeholder>
        <Stack gap={1}>
          <Skeleton length={{ min: 24, max: 32 }} />
          <Skeleton length={{ min: 24, max: 32 }} />
        </Stack>
      </Stack>

      <Table.Body>
        <Skeleton length={{ min: 24, max: 48 }} />
      </Table.Body>

      <Table.Body>
        <Skeleton length={{ min: 8, max: 16 }}>
          <AssistChip />
        </Skeleton>
      </Table.Body>

      <Table.Body />
    </Table.Row>
  );
};
